import { Injectable } from '@angular/core';
import { Http, Jsonp, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';

@Injectable()
export class KlixService {
    private apiUrl = environment.apiUrl;

    constructor(private jsonp: Jsonp,
        private http: Http) { }

    // ========== LOCATIONS API ==========

    getLocations(): Promise<any[]> {
        return this.http.get(`${this.apiUrl}/locations`)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // ========== TARIFS API ==========

    getTarifs(): Promise<any[]> {
        return this.http.get(`${this.apiUrl}/tarifs`)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // ========== DEVIS API ==========

    createDevis(devis: any): Promise<any> {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers });

        return this.http.post(`${this.apiUrl}/devis`, devis, options)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // ========== LEGACY API ==========

    sendMail(mail, sujet, corps): Promise<any> {
        console.log(mail, sujet, corps);
        //cherche = this.replaceAll(cherche, ' ', '_');
        var dataObj =
        {
            mailto: mail,
            subject: sujet,
            corps: corps,
            eleveuid: 'eleveuid'
        };

        return this.http.post('https://webservices.k-lix.com/SendMail.aspx', dataObj).toPromise()
            .then(response => {
                //console.log(response.json());
                return response.json();
            })
            .catch(this.handleError);
        // var newurl = 'https://webservices.k-lix.com/SendMail.aspx?mailto=' + mail + '&subject=' + sujet + '&corps=' + corps + '&eleveuid=' + eleveuid + '&couruid=' + couruid + '&callback=JSONP_CALLBACK';
        // console.log(newurl);
        // //console.log(newurl);
        // // return this.jsonp.get(newurl).toPromise()

        // console.log(this.http.post('https://webservices.k-lix.com/SendMail.aspx', JSON.stringify(dataObj)));

        // return this.http.post('https://webservices.k-lix.com/SendMail.aspx', dataObj).toPromise()
        //     .then(response => {
        //         //console.log(response.json());
        //         return response.json();
        //     })
        //     .catch(this.handleError);
    }

    publiposte(nomfichier, balises) {
        //console.log(nomfichier, balises);
        //cherche = this.replaceAll(cherche, ' ', '_');
        var dataObj = { nomfichier: nomfichier, balises: balises };
        console.log(dataObj);

        return this.http.post('https://webservices.k-lix.com/Publiposte.aspx', dataObj).toPromise()
            .then(response => {
                //console.log(response.json());
                return response.json();
            })
            .catch(this.handleError);
    }

    replaceAll(string, stringToChange, changeWith) {
        return string.replace(new RegExp(`[${stringToChange}]`, 'g'), changeWith)
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}